import React from 'react';

export type NavButtonVariant = 'link' | 'primary' | 'secondary';
export type NavButtonSize = 'sm' | 'md';

export type NavButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: NavButtonVariant;
  size?: NavButtonSize;
};

export const NavButton: React.FC<NavButtonProps> = ({
  children,
  className = '',
  variant = 'link',
  size = 'md',
  type = 'button',
  ...props
}) => {
  const baseClasses =
    'group font-sans font-600 cursor-pointer transition-colors duration-150 !shadow-none !outline-none !ring-0 border border-transparent';
  const sizeClass = size === 'sm' ? 'text-sm leading-5' : 'text-base leading-6';

  let variantClass = '';
  switch (variant) {
    case 'primary':
      variantClass =
        '!text-white hover:!text-white focus-visible:!text-white bg-primaryRed hover:bg-primaryRed/90 border border-primaryRed rounded-lg px-4 py-2';
      break;
    case 'secondary':
      variantClass = 'text-gray-700 bg-white !border-gray-200 rounded-lg px-4 py-2';
      break;
    default:
      variantClass = 'text-gray-600 hover:text-primaryRed bg-transparent border-none p-0';
      break;
  }

  return (
    <button
      type={type}
      className={`${baseClasses} ${sizeClass} ${variantClass} ${className}`.trim()}
      {...props}>
      {children}
    </button>
  );
};

NavButton.displayName = 'NavButton';

export default NavButton;
